import { makeAutoObservable, action } from 'mobx'

class AnimationStore {
	animationState = {
		scale: 0.2,
		opacity: 0.8,
	}

	private animationInterval: NodeJS.Timeout | null = null

	constructor() {
		makeAutoObservable(this)
	}

	@action
	startAnimation() {
		if (this.animationInterval) return

		this.animationInterval = setInterval(() => {
			this.updateAnimationState()

			if (this.animationState.scale >= 1) {
				this.resetAnimation()
			}
		}, 20)
	}

	@action
	updateAnimationState() {
		this.animationState.scale += 0.01
		this.animationState.opacity -= 0.01
	}

	@action
	resetAnimation() {
		this.animationState.scale = 0.2
		this.animationState.opacity = 0.8
	}

	@action
	stopAnimation() {
		if (this.animationInterval) {
			clearInterval(this.animationInterval)
			this.animationInterval = null
		}
	}

	@action
	setZoomAnimationState(scale: number, opacity: number) {
		this.animationState.scale = scale
		this.animationState.opacity = opacity
	}
}

export const animationStore = new AnimationStore()
